import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Badge,
  Row,
  InputGroup,
  Card,
  Form,
} from "react-bootstrap";
import {
  faBell,
  faCheck,
  faList,
  faMinus,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import ReactSwitch from "react-switch";
import {
  addDoc,
  collection,
  doc,
  onSnapshot,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { projectFirestore } from "../../../firebase/config";

function Cobro({ total, register, user, mandarOrden, puntosgenerados, folio }) {
  const [puntos, setPuntos] = useState(0);
  const [imprimir, setImprimir] = useState(true);
  const [userPoints, setUserPoints] = useState({});
  const [metodosPago, setMetodosPago] = useState({
    efectivo: "0",
    tarjeta: "0",
    vale: "0",
    transferencia: "0",
  });
  const quickAmounts = [50, 100, 200, 500, 1000];

  const confirmCobro = async (impres) => {
    if (tot > 0) {
      alert("Aun faltan $" + tot.toFixed(2));
      return;
    }
    let reclamados = false;
    if (userPoints.id) {
      if (puntosgenerados > 0) {
        addDoc(
          collection(projectFirestore, "puntos", userPoints.id, "historial"),
          {
            descripcion: "Obtuviste " + puntosgenerados + " puntos",
            fecha: new Date(),
            folioOrden: folio,
          },
        );
      }
      if (puntos > 0) {
        addDoc(
          collection(projectFirestore, "puntos", userPoints.id, "historial"),
          {
            descripcion: "Se usaron " + puntos + " puntos",
            fecha: new Date(),
            folioOrden: folio,
          },
        );
      }
      setDoc(doc(projectFirestore, "puntos", userPoints.id), {
        id_usuario: user,
        id_local: register.id,
        puntos:
          userPoints.puntos - parseFloat(puntos) + parseFloat(puntosgenerados),
      });
      reclamados = true;
    }
    mandarOrden(imprimir, reclamados, metodosPago, -tot, totmp, puntos);
  };

  const changePago = (e) => {
    if (!isNaN(parseFloat(e.key))) {
      if (
        (parseFloat(metodosPago[e.target.name]) === 0 &&
          metodosPago[e.target.name] !== "0.") ||
        isNaN(parseFloat(metodosPago[e.target.name]))
      ) {
        setMetodosPago({
          ...metodosPago,
          [e.target.name]: e.key,
        });
      } else {
        setMetodosPago({
          ...metodosPago,
          [e.target.name]: metodosPago[e.target.name] + e.key,
        });
      }
    }
    if (e.key === "Backspace") {
      if (
        metodosPago[e.target.name].length === 1 ||
        metodosPago[e.target.name].length === 0
      ) {
        setMetodosPago({
          ...metodosPago,
          [e.target.name]: "0",
        });
      } else {
        setMetodosPago({
          ...metodosPago,
          [e.target.name]: metodosPago[e.target.name].slice(0, -1),
        });
      }
    }
    if (e.key === "." && !metodosPago[e.target.name].includes(".")) {
      setMetodosPago({
        ...metodosPago,
        [e.target.name]: metodosPago[e.target.name] + e.key,
      });
    }
    if (e.key === "Enter") {
      switch (e.target.name) {
        case "efectivo":
          document.getElementById("tarjeta").focus();
          break;
        case "tarjeta":
          document.getElementById("vale").focus();
          break;
        case "vale":
          document.getElementById("transferencia").focus();
          break;
        default:
          break;
      }
    }
  };

  const totmp = Object.keys(metodosPago).reduce((acc, item) => {
    return acc + parseFloat(metodosPago[item]);
  }, 0);

  const tot = parseFloat(total) - puntos - totmp;

  useEffect(() => {
    if (user) {
      let p = query(collection(projectFirestore, "puntos"));
      p = query(
        p,
        where("id_usuario", "==", user),
        where("id_local", "==", register.id),
      );
      onSnapshot(p, async (docd) => {
        docd.docs.forEach((element) => {
          if (element.exists()) {
            let datos = element.data();
            datos.id = element.id;
            setUserPoints(datos);
          }
        });
        if (docd.empty) {
          await addDoc(collection(projectFirestore, "puntos"), {
            id_usuario: user,
            id_local: register.id,
            puntos: 0,
          });
        }
      });
    }
  }, [user, register.id]);

  useEffect(() => {
    if (puntos > total) {
      setPuntos(total);
    }
  }, [total, puntos]);

  return (
    <Card
      id={"Pago"}
      className="shadow-sm payment-card"
      style={{ borderColor: "#00a651", borderWidth: "3px" }}
    >
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="fw-bold text-success m-0">PAGO</h6>
        </div>

        {/* RESUMEN */}

        {userPoints.id ? (
          <>
            <Row className="">
              <Col
                md={6}
                style={{
                  textAlign: "center",
                }}
              >
                <small className="text-muted d-block">
                  Puntos disponibles:
                </small>

                <Badge
                  bg="none"
                  className="px-3 py-2 fs-6"
                  style={{
                    color: "brown",
                    backgroundColor: "#FFE8C1",
                  }}
                >
                  {userPoints.puntos ? userPoints.puntos : 0} pts
                </Badge>
                <br />
                <Button
                  variant="success"
                  onClick={() => {
                    if (userPoints.puntos > parseFloat(total)) {
                      setPuntos(total);
                    } else {
                      setPuntos(userPoints.puntos);
                    }
                  }}
                  style={{ margin: 5, paddingTop: 3, paddingBottom: 3 }}
                >
                  Usar todos
                </Button>
              </Col>

              <Col md={6} style={{ textAlign: "center" }}>
                <small className="text-muted d-block mb-2">Usar puntos</small>
                <InputGroup
                  className="mb-2"
                  style={{ justifyContent: "center" }}
                >
                  <Button
                    variant="light"
                    onClick={() => {
                      if (puntos > 0) setPuntos(puntos - 1);
                    }}
                  >
                    <FontAwesomeIcon icon={faMinus} style={{ fontSize: 13 }} />
                  </Button>
                  <InputGroup.Text style={{ fontSize: 13 }}>
                    {puntos}
                  </InputGroup.Text>
                  <Button
                    variant="light"
                    onClick={() => {
                      if (
                        userPoints.puntos &&
                        puntos < parseFloat(userPoints.puntos) &&
                        parseFloat(total) - puntos > 0
                      ) {
                        setPuntos(puntos + 1);
                      }
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} style={{ fontSize: 13 }} />
                  </Button>
                </InputGroup>
                <Row style={{ textAlign: "center", marginTop: 8 }}>
                  <small className="text-success fw-bold">
                    Valor a descontar: -${puntos.toFixed(2)}
                  </small>
                </Row>
              </Col>
            </Row>
          </>
        ) : (
          <></>
        )}

        {/* MÉTODOS DE PAGO */}
        <Row className="g-3">
          <Col md={12}>
            <Row style={{ alignItems: "end" }}>
              <Col md={3}>
                <label className="form-label fw-semibold">💵 Efectivo</label>

                <Form.Control
                  name="efectivo"
                  id={"efec"}
                  value={parseFloat(metodosPago.efectivo).toFixed(2)}
                  onKeyDown={changePago}
                />
              </Col>

              <Col md={3}>
                <label className="form-label fw-semibold">💳 Tarjeta</label>

                <Form.Control
                  name="tarjeta"
                  id={"tarjeta0"}
                  value={parseFloat(metodosPago.tarjeta).toFixed(2)}
                  onKeyDown={changePago}
                />
              </Col>

              <Col md={3}>
                <label className="form-label fw-semibold">
                  🎟 Vale / Cupón
                </label>

                <Form.Control
                  name="vale"
                  id={"vale"}
                  value={parseFloat(metodosPago.vale).toFixed(2)}
                  onKeyDown={changePago}
                />
              </Col>

              <Col md={3}>
                <label className="form-label fw-semibold">
                  🏦 Transferencia
                </label>

                <Form.Control
                  name="transferencia"
                  id={"transferencia"}
                  value={parseFloat(metodosPago.transferencia).toFixed(2)}
                  onKeyDown={changePago}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <h6>Atajos de efectivo:</h6>
              {quickAmounts.map((item) => (
                <Button
                  variant="ds"
                  key={item}
                  className="newbutton-style filled"
                  id="atajo"
                  onClick={(e) => {
                    setMetodosPago({
                      ...metodosPago,
                      efectivo: "" + item,
                    });
                    document.getElementById("tarjeta0").focus();
                  }}
                >
                  ${item}
                </Button>
              ))}
            </Row>
          </Col>

          <Col md={12}>
            <div className="payment-summary h-100">
              <div className="d-flex justify-content-between">
                <span>Total capturado:</span>

                <span className="text-success fw-bold">
                  ${totmp.toFixed(2)}
                </span>
              </div>

              <div className="d-flex justify-content-between mt-2">
                <span>Restante por cubrir:</span>

                <span className="text-success fw-bold">
                  ${tot > 0 ? tot.toFixed(2) : (0).toFixed(2)}
                </span>
              </div>
              {tot < 0 ? (
                <div className="d-flex justify-content-between mt-2">
                  <span>Cambio</span>

                  <span className="text-success fw-bold">
                    ${Math.abs(tot).toFixed(2)}
                  </span>
                </div>
              ) : (
                <></>
              )}
              <Row>
                <Col md={6} s>
                  <Button
                    variant="ds"
                    className="newbutton-style filled fullspace"
                    id="ticket2"
                    onClick={(e) => setImprimir(!imprimir)}
                  >
                    <FontAwesomeIcon icon={faList} /> Ticket
                    <ReactSwitch
                      id="active"
                      onChange={(e) => setImprimir(!imprimir)}
                      checked={imprimir}
                    />
                  </Button>
                </Col>
                <Col md={6}>
                  <Button
                    variant="ds"
                    className="newbutton-style filled fullspace"
                    id="llamar"
                    // onClick={() => Llamada()}
                  >
                    <FontAwesomeIcon icon={faBell} /> Llamar al cliente
                  </Button>
                </Col>
              </Row>

              <div className="mt-3">
                <Button
                  variant="success"
                  id="efectivo"
                  size="lg"
                  className="w-100"
                  onClick={confirmCobro}
                >
                  {/* <BsCheckCircleFill className="me-2" /> */}
                  <FontAwesomeIcon icon={faCheck} />
                  Confirmar cobro
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default Cobro;
